export default {
  wrapper: {
    display: 'flex',
  },
  mainContainer: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  tableContainer: {
    '@media(max-width: 500px)': {
      maxWidth: 260,
      overflowX: 'auto',
    },
    '@global': {
      'td:nth-child(1)': {
        textAlign: 'left',
        width: '20%',
      },
      'th:nth-child(1)': {
        textAlign: 'left',
        paddingLeft: 28,
        width: '20%',
      },
      'tfoot th': {
        whiteSpace: 'nowrap',
      },
    },
  },
  copyButton: {
    float: 'right',
    marginRight: 30,
    backgroundColor: '#f0405d',
    color: 'white',
    fontSize: 12,
    verticalAlign: 'baseline',
    border: 'none',
    padding: '4px 14px',
  },
  graphContainer: {
    backgroundColor: 'white',
  },
  newestConversionTimestamp: {
    float: 'right',
    marginRight: 30,
    marginTop: 10,
    fontWeight: 700,
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/styles.js